import Header from "./components/header";
import Hero from "./components/hero";
import Overview from "./components/overview";
import Features from "./components/features";
import HowItWorks from "./components/how-it-works";
import Providers from "./components/providers";
import Observability from "./components/observability";
import GitHub from "./components/github";
import CTA from "./components/cta";
import Footer from "./components/footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <Hero />
        <Overview />
        <Features />
        <HowItWorks />
        <Providers />
        <Observability />
        <GitHub />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
